export class SearchRequest {
    name: string;
    address: string;
    phoneNumber: string;
}


// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/_models/searchRequest.ts